import React from 'react';
import './styles/kvalitetssikring.css';
import kvalitetssikringHero from '../images/kvalitetssikring-hero.jpg';
import { FaCheckCircle, FaFileAlt, FaUsers, FaClock, FaCoins, FaShieldAlt } from 'react-icons/fa';
import CTAButton from '../components/CTAButton';
import ContactForm from '../components/contactForm';

function Kvalitetssikring() {
  return (
    <>
      <div className="kvalitetssikring-hero">
        <img src={kvalitetssikringHero} alt="Kvalitetssikring" className="kvalitetssikring-hero-image" />
      </div>

      <section className="kvalitetssikring-intro">
        <div className="kvalitetssikring-container">
          <div className="kvalitetssikring-intro-content">
            <span className="kvalitetssikring-overline">Kvalitetssikring i byggeriet</span>
            <h2>Systematisk kontrol og dokumentation</h2>
            <p className="kvalitetssikring-intro-text">
              Kvalitetssikring (KS) i byggeprojekter er en struktureret proces, der har til formål at sikre, at det udførte arbejde er i overensstemmelse med projektmaterialet, gældende lovgivning, normer og standarder – herunder Bygningsreglementet, DS/EN-standarder og relevante tekniske forskrifter.
            </p>
            <p className="kvalitetssikring-intro-text">
              KS-processen omfatter både planlægning, udførelse og dokumentation af kontroller, og den er et centralt værktøj til at sikre sporbarhed, ansvarlighed og ensartet kvalitet i alle faser af byggeriet.
            </p>
          </div>
        </div>
      </section>

      <section className="kvalitetssikring-why-important">
        <div className="kvalitetssikring-container">
          <h2>Hvorfor er dokumentation vigtig for entreprenøren?</h2>
          <p className="kvalitetssikring-intro-text">
            For entreprenøren er kvalitetssikring og veldokumenteret arbejde ikke blot et krav – det er en strategisk fordel. Når dokumentationen er i orden, står man stærkere i forhold til både bygherre, myndigheder og eventuelle underentreprenører. Det giver gennemsigtighed og mulighed for at dokumentere, at arbejdet er udført korrekt og i overensstemmelse med aftaler og krav.
          </p>
          <p className="kvalitetssikring-intro-text">
            Mangelfuld dokumentation kan føre til tvister, krav om udbedringer og i værste fald økonomiske tab. Omvendt kan god dokumentation:
          </p>
          <ul className="kvalitetssikring-benefits">
            <li>Forebygge konflikter og reducere risikoen for erstatningskrav.</li>
            <li>Understøtte fakturering og ekstraarbejder, fordi det er nemt at dokumentere, hvad der er udført og hvornår.</li>
            <li>Effektivisere interne arbejdsgange, da fejl og misforståelser opdages tidligere.</li>
            <li>Styrke virksomhedens omdømme og konkurrenceevne i udbud, hvor dokumentationskrav ofte vægtes højt.</li>
            <li>Beskytte mod ansvar i tilfælde af fejl, der først opdages længe efter afleveringen.</li>
          </ul>
          <p className="kvalitetssikring-intro-text">
            <strong>Kort sagt: En skarp kvalitetssikring og veldokumenteret byggeproces kan mærkes direkte på bundlinjen – både i form af færre udgifter og bedre indtjening.</strong>
          </p>
        </div>
      </section>

      <section className="ds1140-section">
        <div className="ds1140-content">
          <span className="kvalitetssikring-overline">DS 1140</span>
          <h2>Få styr på DS1140-dokumentationen – uden at drukne i papirarbejde</h2>
          <p>
            DS1140:2019 stiller klare krav til, hvordan entreprenører skal planlægge, udføre og dokumentere almen kontrol af bærende konstruktioner. For mange udførende kan det være en udfordring at få overblik over, hvad der præcist kræves – og hvordan det skal dokumenteres korrekt. Men det behøver ikke være kompliceret.
          </p>
          
          <h3>Slip for usikkerhed og spildtid – brug min dokumentpakke</h3>
          <p>
            Jeg har udviklet en komplet dokumentpakke, der er skræddersyet til DS 1140. Med dokumentpakken får du et solidt grundlag, der sparer dig for tid, fejl og frustrationer – og som samtidig sikrer, at du lever op til kravene i både DS 1140 og Bygningsreglementet.
          </p>
          
          <h3>Samarbejd med mig – og kom sikkert i mål</h3>
          <p>
            Hvis du ønsker mere end bare skabeloner, tilbyder jeg også samarbejde og rådgivning, hvor jeg hjælper dig med at:
          </p>
          <ul className="ds1140-services">
            <li>Tilpasse dokumentationen til dit konkrete projekt</li>
            <li>Implementere en effektiv arbejdsgang for kvalitetssikring</li>
            <li>Undgå faldgruber og sikre, at alt er klar til aflevering</li>
          </ul>
          
          <div className="ds1140-cta">
            <CTAButton text="Book DS 1140 kursus" to="/kursus" />
          </div>
        </div>
      </section>

      <section className="drift-section">
        <div className="section-content">
          <div className="contact-section">
            <div className="contact-content">
              <div className="contact-header">
                <span className="overline">Kontakt os</span>
                <h3>Lad os tale om jeres behov</h3>
                <p className="contact-intro">
                  Vi hjælper jer med at optimere jeres byggeprojekter gennem professionel kvalitetssikring og drift & vedligehold.
                </p>
              </div>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Kvalitetssikring;
